import {
  Directive,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  inject,
  ElementRef,
  Renderer2,
} from '@angular/core';
import { AuthService } from '../services/auth.service';

/**
 * Disables the host element (button, link, etc.) when the current user
 * does not have the required permission.
 * Usage: [appDisableUnlessPermission]="'USER_CREATE'"
 * Or require any of multiple: [appDisableUnlessPermission]="['USER_CREATE', 'USER_UPDATE']"
 */
@Directive({
  selector: '[appDisableUnlessPermission]',
  standalone: true,
})
export class DisableUnlessPermissionDirective implements OnInit, OnChanges {
  private readonly auth = inject(AuthService);
  private readonly el = inject(ElementRef<HTMLElement>);
  private readonly renderer = inject(Renderer2);

  @Input() appDisableUnlessPermission: string | string[] = '';

  ngOnInit(): void {
    this.updateDisabled();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appDisableUnlessPermission']) {
      this.updateDisabled();
    }
  }

  private updateDisabled(): void {
    const hasAccess = this.hasAccess();
    const native = this.el.nativeElement;
    if (hasAccess) {
      this.renderer.removeAttribute(native, 'disabled');
      native.style.setProperty('pointer-events', '');
      native.style.setProperty('opacity', '');
    } else {
      this.renderer.setAttribute(native, 'disabled', 'true');
      native.style.setProperty('pointer-events', 'none');
      native.style.setProperty('opacity', '0.6');
    }
  }

  private hasAccess(): boolean {
    const p = this.appDisableUnlessPermission;
    if (!p) return true;
    if (Array.isArray(p)) {
      return p.length === 0 || this.auth.hasAnyPermission(p);
    }
    return this.auth.hasPermission(p);
  }
}
